import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: theme.spacing(5, 4),
    },
    label: {
      marginBottom: theme.spacing(1),
    },
    url: {
      width: '100%',
    },
    option: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.gray.gray50,
    },
    error: {
      margin: theme.spacing(1),

      '&&': {
        color: COLORS.error.active,
      },
    },
  }),
  { name: 'Form' }
);
